import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/** «Сегодня» в поясе магазина, как `YYYY-MM-DD` (§1). */
export function todayInTz(tz: string): string {
  return dayjs().tz(tz).format('YYYY-MM-DD');
}

export function formatDateTimeInTz(iso: string, tz: string): string {
  return dayjs(iso).tz(tz).format('DD.MM.YYYY HH:mm');
}

export function formatDate(dateOnly: string): string {
  return dayjs(dateOnly).format('DD.MM.YYYY');
}
